<div
    tabindex="-1"
    id="myModal"
    role="dialog"
    class="modal fade in">
    <div class="backdrop"></div>
    <div
        data-show="true"
        role="document"
        class="modal-dialog"
        [class]="modalSize">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    type="button"
                    data-dismiss="modal"
                    aria-label="Close"
                    (click)="remove()"
                    class="close">
                    <i class="nlrp-icon nlrp-icon-close"></i
                ></button>
                <h4 class="modal-title">{{alertModalTitle}}</h4>
            </div>
            <div class="modal-body">
                <div class="container-fluid well">
                    <div class="row">
                        @if (!hasAlertFormValidationModalMessages()) {
                            <div>
                                <div class="col-xs-1">
                                    @if (cssClass === 'warning') {
                                        <i class="nlrp-icon nlrp-icon-warning nlrp-36 alertImageFormat"></i>
                                    }
                                    @if (cssClass === 'error') {
                                        <i class="nlrp-icon nlrp-icon-error nlrp-36 alertImageFormat"></i>
                                    }
                                    @if (cssClass === 'info') {
                                        <i class="nlrp-icon nlrp-icon-info nlrp-36 infoImageFormat"></i>
                                    }
                                    @if (cssClass === 'success') {
                                        <i class="nlrp-icon nlrp-icon-verified-passed nlrp-36 active"></i>
                                    }
                                </div>
                                <div class="col-xs-11 alert-modal-messages">
                                    @for (alert of alertModalMessages; track alert) {
                                        <p class="alertMessageFormat">
                                            <span [innerHtml]="alert | sanitizeResource: 'html'"></span>
                                        </p>
                                    }
                                </div>
                            </div>
                        }

                        @if (hasAlertFormValidationModalMessages()) {
                            <div>
                                <div class="col-xs-12 alert-modal-messages">
                                    <p class="title"
                                        ><b>{{alertFormValidationModalTitle}}</b></p
                                    >
                                    <ul class="failed-fields">
                                        @for (alert of alertFormValidationModalMessages; track alert) {
                                            <li class="alertMessageFormat">
                                                <span ng-bind-html="alert"></span>
                                            </li>
                                        }
                                    </ul>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                @for (butt of alertModalButtons; track butt) {
                    <button
                        type="button"
                        title="{{butt.title}}"
                        [class]="butt.label === 'Cancel' ? 'btn btn-warning nlr-btn-sm' : (butt.btnClasses ? butt.btnClasses : 'btn btn-default nlr-btn-sm')"
                        autofocus
                        [disabled]="isDisabled"
                        (click)="buttonSelected(butt)"
                        >{{butt.label}}
                    </button>
                }
            </div>
        </div>
    </div>
</div>
